var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 465.086,
    height: 257,
    viewBox: "0 0 465.086 257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1261.913 -755.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.086,257Q55.733,245.323,46.1,233.5C-95.059,60.621,123.627,157.595,224.778,0H416.142a25,25,0,0,1,25,25V232a25,25,0,0,1-25,25Z",
    transform: "translate(1726.997 1012.996) rotate(180)",
    fill: "#028d63",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.086,257Q55.733,245.323,46.1,233.5C-95.059,60.621,123.627,157.595,224.778,0H416.142a25,25,0,0,1,25,25V232a25,25,0,0,1-25,25Z",
    transform: "translate(1703.056 1012.996) rotate(180)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380.754 779.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.4,0H6.062A6.061,6.061,0,0,0,0,6.062V196.8a6.061,6.061,0,0,0,6.062,6.062H197.4a6.061,6.061,0,0,0,6.062-6.062V6.062A6.061,6.061,0,0,0,197.4,0Zm0,0",
    transform: "translate(0 0)",
    fill: "#08737d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.658,6.062V196.8a6.061,6.061,0,0,1-6.062,6.062H345.488V0H405.6a6.061,6.061,0,0,1,6.062,6.062Zm0,0",
    transform: "translate(-208.195)",
    fill: "#08737d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.463,28.806V196.439a6.425,6.425,0,0,1-6.425,6.425H6.425A6.425,6.425,0,0,1,0,196.439V6.425A6.425,6.425,0,0,1,6.425,0H70.389a6.064,6.064,0,0,1,5.728,4.075L83.2,24.488a6.427,6.427,0,0,0,6.071,4.319Zm0,0",
    transform: "translate(0 0)",
    fill: "#e4e4e4",
    stroke: "#c5c5c2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.439,148.345a33.989,33.989,0,1,1-26.2-33.039,6.759,6.759,0,0,1-3.14,13.148,20.471,20.471,0,1,0,14.865,26.153H212.66a5.844,5.844,0,1,1,0-11.689h20.3a5.462,5.462,0,0,1,5.477,5.427Zm0,0",
    transform: "translate(-102.715 -68.94)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.938,191.584v.056a33.994,33.994,0,0,1-34.688,33.986V212.106a20.5,20.5,0,0,0,20.216-14.259H263.159a5.845,5.845,0,0,1,0-11.69h20.3a5.464,5.464,0,0,1,5.475,5.428Zm0,0",
    transform: "translate(-153.214 -112.18)",
    fill: "#0fa9dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.739,125.009a6.779,6.779,0,0,1-7.557,3.446,20.463,20.463,0,0,0-19.542,5.883l-9.825-9.283a33.976,33.976,0,0,1,32.507-9.748A6.752,6.752,0,0,1,230.739,125.009Zm0,0",
    transform: "translate(-116.796 -68.941)",
    fill: "#ff6426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.234,244.628a33.991,33.991,0,0,1-49.417,0l9.826-9.283a20.471,20.471,0,0,0,29.767,0Zm0,0",
    transform: "translate(-116.796 -141.821)",
    fill: "#6fbf6b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.461 13.528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.273,40.468a6.426,6.426,0,1,1-6.425-6.425A6.425,6.425,0,0,1,54.273,40.468Zm0,0",
    transform: "translate(-41.422 -34.043)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.973,46.893H93.553a6.425,6.425,0,1,1,0-12.85h18.42a6.425,6.425,0,0,1,0,12.85Zm0,0",
    transform: "translate(-68.965 -34.043)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,327.753a6.061,6.061,0,0,1-6.062,6.062h-114.5a6.062,6.062,0,1,1,0-12.123h114.5A6.063,6.063,0,0,1,223.3,327.753Zm0,0",
    transform: "translate(-74.721 -207.383)",
    fill: "#0cb2c2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.25,333.815H256V321.691h57.25a6.062,6.062,0,1,1,0,12.123Zm0,0",
    transform: "translate(-154.268 -193.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,389.113a6.063,6.063,0,0,1-6.062,6.062h-114.5a6.062,6.062,0,0,1,0-12.124h114.5A6.061,6.061,0,0,1,223.3,389.113Zm0,0",
    transform: "translate(-58.26 -230.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,450.464a6.064,6.064,0,0,1-6.062,6.062h-114.5a6.062,6.062,0,1,1,0-12.123h114.5A6.063,6.063,0,0,1,223.3,450.464Zm0,0",
    transform: "translate(-58.26 -267.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.312,450.464a6.064,6.064,0,0,1-6.062,6.062H256V444.4h57.25A6.063,6.063,0,0,1,319.312,450.464Zm0,0",
    transform: "translate(-154.268 -267.802)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.312,389.113a6.063,6.063,0,0,1-6.062,6.062H256V383.051h57.25A6.061,6.061,0,0,1,319.312,389.113Zm0,0",
    transform: "translate(-154.268 -230.831)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1344.516 909.603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.738,47.738,91,52l7.738,4.259L103,63.995l4.259-7.738L114.995,52l-7.738-4.259L103,40Z",
    transform: "translate(-91 -40)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1344.516 789.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.547,28.547,427,33.251l8.547,4.7,4.7,8.547,4.7-8.547,8.547-4.7-8.547-4.7L440.251,20Z",
    transform: "translate(-445 -12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1616.516 854.368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.547,28.547,427,33.251l8.547,4.7,4.7,8.547,4.7-8.547,8.547-4.7-8.547-4.7L440.251,20Z",
    transform: "translate(-427 -20)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAr);
export default __webpack_public_path__ + "static/media/google_ar.621dbb8579e6ed260a3373053895265e.svg";
export { ForwardRef as ReactComponent };